import React from 'react';
import PropTypes from 'prop-types';

// MUI
import Checkbox from "@mui/material/Checkbox";

// Components
import {BpCheckedIcon, BpIcon} from "components/WMS/AccordionShipment/checkboxIcons";

// Assets
import {blueColor} from "assets/jss/main";

ContainerCheckbox.propTypes = {
    onClick: PropTypes.func.isRequired,
    checked: PropTypes.bool.isRequired
};

function ContainerCheckbox({onClick, checked}) {
    return (
        <Checkbox
            onClick={onClick}
            checked={checked}
            icon={<BpIcon/>}
            checkedIcon={<BpCheckedIcon/>}
            sx={{
                marginRight: '8px',
                color: blueColor,
                '&.Mui-checked': {color: blueColor}
            }}
        />
    );
}

export default ContainerCheckbox;
